import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=53dc4f45&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=js&"
export * from "./AuthPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=53dc4f45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc4f45",
  null
  
)

export default component.exports